import script from "./BottomDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomDialog.vue?vue&type=script&setup=true&lang=js"

import "./BottomDialog.vue?vue&type=style&index=0&id=ff92c72e&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff92c72e"]])

export default __exports__